import { render, staticRenderFns } from "./AddSchool.vue?vue&type=template&id=4b8d7906&scoped=true&"
import script from "./AddSchool.vue?vue&type=script&lang=js&"
export * from "./AddSchool.vue?vue&type=script&lang=js&"
import style0 from "./AddSchool.vue?vue&type=style&index=0&id=4b8d7906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8d7906",
  null
  
)

export default component.exports